import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';

const PayCurrentAmountPromptWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 30px 25px 60px;
  background: white;
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 45px 80px 60px;
  }
`;

const Heading = styled.h2`
  ${(props) => props.theme.font.heading.v100};
  color: ${(props) => props.theme.color.primary.v600};
  margin: 0 0 10px;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.6;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: ${(props) => props.theme.font.weight.v100};
  margin: 10px 0;
  text-align: center;
  white-space: pre-line;
  ${(props) => props.theme.font.subhead.v400};
  line-height: 1.6;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 575px;
    ${(props) => props.theme.font.subhead.v500};
  }
`;

const PayCurrentAmountButton = styled(PrimaryButton)`
  text-transform: uppercase;
  margin: 15px 0;
  ${(props) => props.theme.font.body.v100}
`;

export { PayCurrentAmountPromptWrapper, Heading, Body, PayCurrentAmountButton };
